import { FetchEventOptionsResponseOptions } from '../../swagger'
import { UseFetchEventOptionsHook } from './useFetchEventOptions'

export const getEventTypes = (
  eventTypes: FetchEventOptionsResponseOptions['eventTypes']
): UseFetchEventOptionsHook['eventTypes'] => {
  const groupedEventTypes = eventTypes.reduce(
    (eventTypesByCategory, eventType) => {
      /**
       * This should never happen since all event types should have a category,
       * but given the category property is optional in the interface
       * we add a fallback to silent ts errors.
       */
      const categoryKey = eventType.category || 'Uncategorized'

      if (!eventTypesByCategory[categoryKey])
        eventTypesByCategory[categoryKey] = []

      eventTypesByCategory[categoryKey].push({
        id: eventType.name,
        name: eventType.name,
      })

      return eventTypesByCategory
    },
    {} as UseFetchEventOptionsHook['eventTypes']
  )

  return groupedEventTypes
}

export const getLeadershipTrainingRoles = (
  leadershipTrainingRoles: FetchEventOptionsResponseOptions['leadershipTrainingRoles']
): UseFetchEventOptionsHook['leadershipTrainingRoles'] => {
  return leadershipTrainingRoles?.map(({ name }) => name) || []
}
